module.exports = __webpack_public_path__ + "img/avatar1.01df92d3.png";